import React, { useEffect } from 'react'
import Select from "react-select";
import { useTranslation } from "react-i18next";
import useTheme from '../../hooks/useTheme';

//valForDifferentMessage-vrednost koja se ispituje da bi se proverilo koja poruka tacno treba da se prikaze

const CustomSelectList = ({ ...props }) => {

  const { isOverflow, setIsOverflow } = useTheme();
  const { t } = useTranslation();

  return (
    <Select
      noOptionsMessage={() =>
        'valForDifferentMessage' in props
          ? props?.valForDifferentMessage
            ? t("noResult")
            : props?.message
          : t("noResult")
      }
      placeholder={t("SelectFromList")}
      menuPosition="fixed"
      onMenuOpen={() => {
        // setTimeout(()=>{
        //   const selectedEl = document.getElementsByClassName(`${props.classNamePrefix}__control--is-focused`)[0];
        //   if(selectedEl){
        //     selectedEl.scrollIntoView({behavior:'smooth'});
        //   }
        // },15);
        setIsOverflow(true)
      }}
      onMenuClose={() => setIsOverflow(false)}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary50: "#e9f5f2",
          primary25: "#e9f5f2",
          primary: "#00c58f",
        },
      })}
      
      {...props}
    />
  );
}

export default CustomSelectList